import {createContext, useContext} from "react";

type PccMappingFormContextValue = Readonly<{
  isUpdating: boolean;
}>;

export const PccMappingFormContext = createContext<PccMappingFormContextValue>({
  isUpdating: false,
});

export const usePccMappingFormContext = () => useContext(PccMappingFormContext);
